export default __webpack_public_path__ + "assets/wave-vertical.289afc91.svg";